export default __webpack_public_path__ + "static/media/sj.b52dcbb4.jpg";